import React, { useEffect } from "react";
import { Flex, Spinner } from "theme-ui";
import { Button } from "./PSY/Button";

import { LiquityStoreState } from "@liquity/lib-base";
import { useLiquitySelector } from "@liquity/lib-react";

import { useLiquity } from "../hooks/LiquityContext";

import { Transaction, useMyTransactionState } from "./Transaction";
import { useTroveView } from "./Trove/context/TroveViewContext";
import { getContractAddressByCollateralKey } from "@liquity/lib-ethers"

const select = ({ collateralStates }: LiquityStoreState) => collateralStates;

type Props = {
  collateralKey: string;
}

export const CollateralSurplusAction: React.FC<Props> = ({ collateralKey }) => {
  const collateralStates = useLiquitySelector(select);
  const { collateralSurplusBalance } = collateralStates[collateralKey]
  const {
    liquity
  } = useLiquity();

  const { assetAddress } = getContractAddressByCollateralKey(liquity.connection, collateralKey);

  const myTransactionId = "claim-coll-surplus";
  const myTransactionState = useMyTransactionState(myTransactionId);

  const { dispatchEvent } = useTroveView();

  useEffect(() => {
    if (myTransactionState.type === "confirmedOneShot") {
      dispatchEvent("TROVE_SURPLUS_COLLATERAL_CLAIMED");
    }
  }, [myTransactionState.type, dispatchEvent]);

  return myTransactionState.type === "waitingForApproval" ? (
    <Flex variant="layout.actions">
      <Button disabled>
        <Spinner sx={{ mr: 2, color: "white" }} size="20px" />
        Waiting for your approval
      </Button>
    </Flex>
  ) : myTransactionState.type !== "waitingForConfirmation" &&
    myTransactionState.type !== "confirmed" &&
    !!assetAddress ? (
    <Flex variant="layout.actions">
      <Transaction
        id={myTransactionId}
        send={liquity.send.claimCollateralSurplus.bind(liquity.send, assetAddress, undefined)}
      >
        <Button>Claim</Button>
      </Transaction>
    </Flex>
  ) : null;
};
